import { render, staticRenderFns } from "./SkillSets.vue?vue&type=template&id=452f722f&scoped=true"
import script from "@/views/Curricula/SkillSets.ts?vue&type=script&lang=ts&external"
export * from "@/views/Curricula/SkillSets.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Curricula/skill-sets.scss?vue&type=style&index=0&id=452f722f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f722f",
  null
  
)

export default component.exports